import React, { useMemo } from "react";

type UserStatusProps = {
  state?: string;
  lastActivity?: number;
  showText?: boolean;
};

const UserStatus: React.FC<UserStatusProps> = ({
  state,
  lastActivity,
  showText = false,
}) => {
  const status = useMemo(() => {
    if (state === "offline") {
      return "offline";
    }

    const diff = Date.now() - (lastActivity || 0);

    if (diff < 5 * 60 * 1000) {
      return "online";
    }

    return "away";
  }, [state, lastActivity]);

  if (status === "offline") {
    return null;
  }

  if (!showText) {
    return (
      <span
        className={`pill ${status === "online" ? "pill-online" : "pill-away"}`}
      />
    );
  }

  return (
    <>
      <span
        className={`pill ${status === "online" ? "pill-online" : "pill-away"}`}
      />
      <span className="pill-text">
        {status === "online" ? "Online" : "Ausente"}
      </span>
    </>
  );
};

export default UserStatus;
